import {getLoanRateComparatorData} from "@/app/(pages)/taux-pret-immobilier/endpoint"

const BASE_API = '/api/loan-rate-comparator'
export const AFFILIATED_LINK = 'https://reassurez-moi.app.pretto.fr/'

export const API_ENDPOINTS = {
    GET_BANK_RATES: `${BASE_API}/get-bank-rates`,
}

export const MIN_LOAN_DURATION_YEAR = 10
export const MAX_LOAN_DURATION_YEAR = 25
export const DEFAULT_LOAN_YEAR_DURATION = 20

export const MIN_LOAN_AMOUNT = 30000
export const MAX_LOAN_AMOUNT = 10000000
export const DEFAULT_LOAN_AMOUNT = 200000

export const MIN_BORROWER_AGE = 18
export const MAX_BORROWER_AGE = 100
export const DEFAULT_BORROWER_AGE = 30
